module.exports = __webpack_public_path__ + "img/SK36861146.52b0a28e.png";